import React,{useEffect,useState,useContext} from 'react'
import axios from 'axios'
import { AuthContextUser } from "../context/UserContext";
import { ToastContainer, toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import moment from "jalali-moment";

export const SicknessPeriod = () => {

    const { currentUser } = useContext(AuthContextUser);

    const [name,setName] = useState('')
    const [meli,setMeli] = useState('')
    const [tel,setTel] = useState('')
    const [year,setYesr] = useState('')
    const [insu,setInsu] = useState('')
    const [loca,setLock] = useState('')

const submitHandel = async() =>{
        await axios.post("https://clinic.salamatpayanew.ir/Register/patients",{
            name:name,
            meli:meli,
            tel:tel,
            year:year,
            insu:insu.replace("/","-").replace("/","-"),
            password:meli,
            nezam:currentUser.nezam,
            loca:loca
        }).then(() =>{
            toast.success("عملیات ثبت اطلاعات بیمار با موفقیت انجام شد")
            patwrite();
        }).catch((err) =>{
            toast.warning("خطا در ثبت اطلاعات کاربر تکراری")
        })
 }
 
 const patwrite = async() => {
    await axios.post("https://clinic.salamatpayanew.ir/Register/pat_writeTo",{
        nezam:currentUser.nezam,
        meli:meli,
        date:insu.replace("/","-").replace("/","-"),
    }).then(() =>{
        
    }).catch((err) =>{
        
    })
 }
 
const handelSubmit = async() => {
        await axios.post('https://clinic.salamatpayanew.ir/Register/patientsTwo',{
            name:name,
            meli:meli,
            tel:tel,
            year:year,
            insu:insu.replace("/","-").replace("/","-"),
            password:meli,
            nezam:currentUser.nezam
  }).then(() =>{
      toast.success("عملیات ارجاع پرونده به پزشک انتخابی انجام شد")
  }).catch((err) =>{
      toast.warning("خطا در ارجاع پرونده")
  })
}

const handelSendUser = async() => {
    if(!name || !meli){
          toast.warning('فیلدها نمی تواند خالی باشد')  
    }else{
    await axios.post("https://clinic.salamatpayanew.ir/Register/inseertSend",{
        name:name,
        meli:meli,
        year:year,
        nezam:currentUser.nezam,
        date: moment(new Date(), "YYYY-MM-DD").locale("fa").format("YYYY-MM-DD"),
        insu:insu.replace("/","-").replace("/","-"),
    }).then(() => {
        toast.success("ارجاع با موفقیت انجام شد")
    }).catch((err) =>{
        toast.warning("این بیمار به پزشک ارجاع شده است")
    })
  }
}


if (currentUser.meli === null) {
} else {
  return (
    <>
     <section class="m-0 content" dir='rtl'>
            <div class="d-flex flex-column justify-content-start align-items-center">
                <div class="card">
                    <img src="../img/dr02.png" class="position-absolute form-img" alt="" />
                    <div class="d-flex flex-column justify-content-start card-title-container">
                        <div class="card-title text-secondary">ثبت بیمار</div>
                    </div>
                    <p></p>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100 t-24">
                        <div class="custom-form-control form-group position-relative w-50 me-md-3">
                            <input type="text" maxLength={80} class="form-control pr-16 my-2" placeholder='نام و نام خانوادگی' onChange={(e) => setName(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                            <input type="text" maxLength={10} class="form-control pr-16 my-2" placeholder="کد ملی"  onChange={(e) => setMeli(e.target.value)}/>
                        </div>
          
                    </div>
  <div class="d-flex flex-column flex-md-row justify-content-between w-100">
             <div class="custom-form-control form-group position-relative w-100 m-0 me-md-3">
                            <input type="text" maxLength={11} class="form-control pr-16 my-2" placeholder="شماره همراه" onChange={(e) => setTel(e.target.value)} />
                        </div>
                        <div class="custom-form-control form-group position-relative w-100 m-0 me-md-3">
                            <input type="text" maxLength={10} class="form-control pr-16 my-2" placeholder="تاریخ تولد" onChange={(e) => setInsu(e.target.value)}/>
                </div>

                    <div class="custom-form-control form-group position-relative w-100 me-md-3">
                            <select class="form-select form-control pr-16 my-2" aria-label="Default select example" onChange={(e) => setYesr(e.target.value)}>
                                <option selected>نوع بیمه</option>
                                <option value="آزاد">آزاد</option>
                                <option value="نیر وهای مسلح">نیروهای مسلح</option>
                                <option value="تامین اجتماعی">تامین اجتماعی</option>
                            </select>
                        </div>
                        <div class="custom-form-control form-group position-relative w-100 me-md-3">
                            <select class="form-select form-control pr-16 my-2" aria-label="Default select example" onChange={(e) => setLock(e.target.value)}>
                                <option selected>انتخاب اتباع</option>
                                <option value="افغانی">افغانی</option>
                                <option value="عرب">عرب</option>
                                <option value="سایر">سایر</option>
                            </select>
                        </div>
                    </div>
                    <br />
                    <div class="custom-form-control form-group position-relative w-50 me-md-3">
                    <button class="btn btn-success ms-3" onClick={submitHandel}>
                        ثبت اطلاعات بیمار
                    </button>
                    <button class="btn btn-primary" onClick={handelSendUser}>
                        ارجاع به پزشک
                    </button>
                    </div>
                </div>
            </div>
            <div class="custom-form-control form-group position-relative w-50 ms-3">
                        <button className='btn btn-dark mt-4' onClick={handelSubmit}>ارجاع پرونده بیمار به پزشک انتخابی</button>
            </div>  
        </section>

     <ToastContainer
        position="top-center"
        autoClose={20000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

    </>
  )
  }
}
